import React  from 'react';
import {useStyles} from "./styles/LoginStyle";
import {
    Box,
    Button,
    Typography,
} from "@material-ui/core";
import {observer} from "mobx-react";
import {useHistory} from "react-router-dom";
import {URL_TYPE} from "../../../routes/Routes";
import {injectIntl} from "react-intl";


function PwResetCompleted(props) {
    const classes = useStyles();
    const history = useHistory();
    const {intl} = props;

    return (
        <Box className={classes.root}>
            <Box className={classes.loginBox}>
                <Box className={classes.boxInner}>
                    <Typography className={classes.resetText}>{intl.formatMessage({id: "msg_success_reset_password"})}</Typography>
                    <Box display={"flex"} justifyContent={"center"} alignItems={"center"}>
                        <Button className={classes.resetLogin} onClick={() => history.push(URL_TYPE.Login)} disableRipple>
                            <Typography>{intl.formatMessage({id: "login"})}</Typography>
                        </Button>
                    </Box>
                </Box>
            </Box>
        </Box>
    );
}

export default injectIntl(observer(PwResetCompleted));
